<template>
  <div class="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
    <!-- Header with gradient -->
    <div class="mb-6 sm:mb-8 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 rounded-xl p-5 sm:p-6 shadow-lg">
      <h1 class="text-2xl sm:text-3xl font-bold text-white">แดชบอร์ด</h1>
      <p class="mt-2 text-sm sm:text-base text-white text-opacity-90">ยินดีต้อนรับสู่ระบบจัดการยานพาหนะและคนขับ</p>
    </div>

    <!-- Main menu cards with gradient -->
    <div class="hidden sm:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
      <RouterLink
        to="/vehicles"
        class="group bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-200"
      >
        <div class="h-2 bg-gradient-to-r from-blue-500 to-cyan-500"></div>
        <div class="p-5 sm:p-6">
          <div class="flex items-center mb-4">
            <div class="p-3 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl shadow-lg group-hover:scale-110 transition-transform duration-300">
              <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
          <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-2">ยานพาหนะ</h2>
          <p class="text-sm text-gray-600">จัดการข้อมูลและสถานะของยานพาหนะ</p>
        </div>
      </RouterLink>

      <RouterLink
        to="/drivers"
        class="group bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-200"
      >
        <div class="h-2 bg-gradient-to-r from-purple-500 to-pink-500"></div>
        <div class="p-5 sm:p-6">
          <div class="flex items-center mb-4">
            <div class="p-3 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl shadow-lg group-hover:scale-110 transition-transform duration-300">
              <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
          </div>
          <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-2">คนขับ</h2>
          <p class="text-sm text-gray-600">จัดการข้อมูลและความพร้อมของคนขับ</p>
        </div>
      </RouterLink>

      <RouterLink
        to="/schedules"
        class="group bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-200"
      >
        <div class="h-2 bg-gradient-to-r from-indigo-500 to-purple-500"></div>
        <div class="p-5 sm:p-6">
          <div class="flex items-center mb-4">
            <div class="p-3 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl shadow-lg group-hover:scale-110 transition-transform duration-300">
              <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
          <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-2">ตารางงาน</h2>
          <p class="text-sm text-gray-600">สร้างและจัดการตารางการใช้ยานพาหนะ</p>
        </div>
      </RouterLink>

      <RouterLink
        to="/reports"
        class="group bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-200"
      >
        <div class="h-2 bg-gradient-to-r from-orange-500 to-red-500"></div>
        <div class="p-5 sm:p-6">
          <div class="flex items-center mb-4">
            <div class="p-3 bg-gradient-to-br from-orange-500 to-red-500 rounded-xl shadow-lg group-hover:scale-110 transition-transform duration-300">
              <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
          </div>
          <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-2">รายงาน</h2>
          <p class="text-sm text-gray-600">สร้างรายงานการใช้งานและการวิเคราะห์</p>
        </div>
      </RouterLink>
    </div>

    <!-- Today's Schedule Section -->
    <div class="mt-8 sm:mt-12">
      <!-- Date Navigation Header -->
      <div class="flex items-center justify-between mb-4 sm:mb-6 rounded-xl p-4 shadow-md" :style="{ background: `linear-gradient(135deg, ${dayOfWeekColor}, ${dayOfWeekColorLight})` }">
        <button
          @click="previousDay"
          class="p-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg transition-all duration-200 backdrop-blur-sm"
          title="วันก่อนหน้า"
        >
          <svg class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <h2 class="text-lg sm:text-xl font-bold text-white text-center drop-shadow-md">
          {{ selectedDateDisplay }}
        </h2>

        <button
          @click="nextDay"
          class="p-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-lg transition-all duration-200 backdrop-blur-sm"
          title="วันถัดไป"
        >
          <svg class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      <div v-if="filteredSchedules.length === 0" class="bg-gradient-to-r from-gray-50 to-slate-50 rounded-xl p-8 text-center border border-gray-200">
        <svg class="mx-auto h-12 w-12 text-gray-400 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <p class="text-gray-600 font-medium">ไม่มีงานที่กำหนดไว้สำหรับวันที่นี้</p>
        <p class="text-sm text-gray-500 mt-1">คุณสามารถสร้างตารางงานใหม่ได้ที่หน้าตารางงาน</p>
      </div>
      <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        <div
          v-for="schedule in filteredSchedules"
          :key="schedule.id"
          class="bg-white shadow-xl rounded-lg text-gray-900 overflow-hidden"
        >
          <!-- Vehicle Header Image -->
          <div class="rounded-t-lg h-32 overflow-hidden bg-gradient-to-br from-blue-400 to-indigo-500">
            <img
              v-if="schedule.vehicle?.imageUrl"
              class="object-cover object-center w-full h-full"
              :src="schedule.vehicle.imageUrl"
              :alt="schedule.vehicle?.registrationNumber || 'รถ'"
              @error="onVehicleImageError"
            >
            <!-- Fallback icon for vehicle if no image -->
            <div v-else class="w-full h-full flex items-center justify-center">
              <svg class="h-16 w-16 text-white opacity-80" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>

          <!-- Driver Avatar (overlapping) -->
          <div class="mx-auto w-32 h-32 relative -mt-16 border-4 border-white rounded-full overflow-hidden"
            :style="schedule.driver?.color ? { backgroundColor: schedule.driver.color } : {}"
            :class="!schedule.driver?.avatarImage && !schedule.driver?.color ? 'bg-gradient-to-br from-purple-500 to-pink-500' : ''"
          >
            <img
              v-if="schedule.driver?.avatarImage"
              class="object-cover object-center h-32 w-32"
              :src="schedule.driver.avatarImage"
              :alt="schedule.driver?.fullName || 'คนขับ'"
              @error="onDriverImageError"
            >
            <svg v-else class="h-16 w-16 text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>

          <!-- Driver Name & Vehicle Info -->
          <div class="text-center mt-2 px-4">
            <h2 class="font-semibold text-lg text-gray-900">{{ schedule.driver?.fullName || 'ไม่ระบุคนขับ' }}</h2>
            <p class="text-gray-500 text-sm">{{ schedule.vehicle?.registrationNumber || 'ไม่ระบุรถ' }}</p>
          </div>

          <!-- Job Details -->
          <ul class="py-4 mt-2 text-gray-700 flex items-center justify-around">
            <!-- Time -->
            <li class="flex flex-col items-center justify-around">
              <svg class="w-5 h-5 fill-current text-blue-900 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div class="text-xs text-center">{{ formatTime(schedule.startTime) }} - {{ formatTime(schedule.endTime) }}</div>
            </li>

            <!-- Vehicle Type -->
            <li class="flex flex-col items-center justify-around">
              <svg class="w-5 h-5 fill-current text-blue-900 mb-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M8 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM15 16.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                <path d="M3 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1.05a2.5 2.5 0 0 1 4.9 0H10V5a1 1 0 0 0-1-1H3zM14 7a1 1 0 0 0-1 1v8.05a2.5 2.5 0 0 1 4.9 0H19a1 1 0 0 0 1-1v-5l-2-3h-4z"/>
              </svg>
              <div class="text-xs">{{ schedule.vehicle?.vehicleType || 'ไม่ระบุ' }}</div>
            </li>

            <!-- Status -->
            <li class="flex flex-col items-center justify-around">
              <div
                :class="getStatusButtonClass(schedule)"
                class="px-3 py-1 text-xs font-semibold rounded-full border"
              >
                {{ getStatusText(schedule) }}
              </div>
            </li>
          </ul>

          <!-- Notes Section -->
          <div v-if="schedule.notes" class="p-4 border-t mx-4 mt-2">
            <div class="flex items-start gap-2">
              <svg class="h-4 w-4 text-amber-500 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <p class="text-xs text-gray-600 line-clamp-2">{{ schedule.notes }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick stats section -->
    <div class="mt-8 sm:mt-12">
      <h2 class="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6">ภาพรวมด่วน</h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        <div class="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden">
          <div class="h-1.5 bg-gradient-to-r from-blue-500 to-cyan-500"></div>
          <div class="p-5 sm:p-6">
            <div class="flex items-center">
              <div class="p-3 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl shadow-md group-hover:scale-110 transition-transform duration-300">
                <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-xs sm:text-sm font-medium text-gray-600">ยานพาหนะทั้งหมด</p>
                <p class="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">{{ vehicleCount }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden">
          <div class="h-1.5 bg-gradient-to-r from-purple-500 to-pink-500"></div>
          <div class="p-5 sm:p-6">
            <div class="flex items-center">
              <div class="p-3 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl shadow-md group-hover:scale-110 transition-transform duration-300">
                <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-xs sm:text-sm font-medium text-gray-600">คนขับทั้งหมด</p>
                <p class="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">{{ driverCount }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="group bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 overflow-hidden">
          <div class="h-1.5 bg-gradient-to-r from-indigo-500 to-purple-500"></div>
          <div class="p-5 sm:p-6">
            <div class="flex items-center">
              <div class="p-3 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl shadow-md group-hover:scale-110 transition-transform duration-300">
                <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <div class="ml-4">
                <p class="text-xs sm:text-sm font-medium text-gray-600">ตารางงานที่ใช้งาน</p>
                <p class="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">{{ scheduleCount }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { RouterLink } from 'vue-router'
import { useVehicleStore } from '../stores/vehicleStore'
import { useDriverStore } from '../stores/driverStore'
import { useScheduleStore } from '../stores/scheduleStore'
import type { ScheduleEntry } from '../types/schedule'

const vehicleStore = useVehicleStore()
const driverStore = useDriverStore()
const scheduleStore = useScheduleStore()

const vehicleCount = computed(() => vehicleStore.vehicles.length)
const driverCount = computed(() => driverStore.drivers.length)
const scheduleCount = computed(() => scheduleStore.scheduleEntries.length)

// Current time for real-time updates
const currentTime = ref(new Date())
let timerInterval: number | null = null

// Selected date for viewing schedules (default to today)
const selectedDate = ref(new Date())

// Get schedules for selected date
const filteredSchedules = computed(() => {
  const selected = new Date(selectedDate.value)
  selected.setHours(0, 0, 0, 0)

  return scheduleStore.scheduleEntries.filter(schedule => {
    const scheduleDate = new Date(schedule.startDate || schedule.usageDate!)
    scheduleDate.setHours(0, 0, 0, 0)
    return scheduleDate.getTime() === selected.getTime()
  })
})

// Display selected date in Thai format
const selectedDateDisplay = computed(() => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const selected = new Date(selectedDate.value)
  selected.setHours(0, 0, 0, 0)

  if (selected.getTime() === today.getTime()) {
    return 'งานวันนี้'
  }

  const thaiMonths = [
    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
  ]

  const thaiDays = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']

  const day = selected.getDate()
  const month = thaiMonths[selected.getMonth()]
  const year = selected.getFullYear() + 543
  const dayName = thaiDays[selected.getDay()]

  return `${dayName}ที่ ${day} ${month} ${year}`
})

// Get day of week color (Thai tradition)
const dayOfWeekColors = {
  0: { main: '#DC2626', light: '#EF4444' },   // Sunday - Red (อาทิตย์ - แดง)
  1: { main: '#EAB308', light: '#FACC15' },   // Monday - Yellow (จันทร์ - เหลือง)
  2: { main: '#EC4899', light: '#F472B6' },   // Tuesday - Pink (อังคาร - ชมพู)
  3: { main: '#10B981', light: '#34D399' },   // Wednesday - Green (พุธ - เขียว)
  4: { main: '#F97316', light: '#FB923C' },   // Thursday - Orange (พฤหัสบดี - ส้ม)
  5: { main: '#3B82F6', light: '#60A5FA' },   // Friday - Blue (ศุกร์ - ฟ้า)
  6: { main: '#9333EA', light: '#A855F7' }    // Saturday - Purple (เสาร์ - ม่วง)
}

const dayOfWeekColor = computed(() => {
  const dayIndex = selectedDate.value.getDay()
  return dayOfWeekColors[dayIndex as keyof typeof dayOfWeekColors].main
})

const dayOfWeekColorLight = computed(() => {
  const dayIndex = selectedDate.value.getDay()
  return dayOfWeekColors[dayIndex as keyof typeof dayOfWeekColors].light
})

// Navigate to previous day
const previousDay = () => {
  const newDate = new Date(selectedDate.value)
  newDate.setDate(newDate.getDate() - 1)
  selectedDate.value = newDate
}

// Navigate to next day
const nextDay = () => {
  const newDate = new Date(selectedDate.value)
  newDate.setDate(newDate.getDate() + 1)
  selectedDate.value = newDate
}

// Format time helper
const formatTime = (time: string): string => {
  if (!time) return ''
  const parts = time.split(':')
  if (parts.length >= 2) {
    return `${parts[0]}:${parts[1]}`
  }
  return time
}

// Get status of schedule
const getScheduleStatus = (schedule: ScheduleEntry): 'upcoming' | 'active' | 'completed' => {
  const now = new Date()
  const scheduleDate = new Date(schedule.startDate || schedule.usageDate!)
  const [startHour, startMinute] = schedule.startTime.split(':').map(Number)
  const [endHour, endMinute] = schedule.endTime.split(':').map(Number)

  const startDateTime = new Date(scheduleDate)
  startDateTime.setHours(startHour, startMinute, 0, 0)

  const endDateTime = new Date(scheduleDate)
  endDateTime.setHours(endHour, endMinute, 0, 0)

  if (now < startDateTime) {
    return 'upcoming'
  } else if (now >= startDateTime && now <= endDateTime) {
    return 'active'
  } else {
    return 'completed'
  }
}

// Get status bar color based on status
const getStatusBarColor = (schedule: ScheduleEntry): string => {
  const status = getScheduleStatus(schedule)
  switch (status) {
    case 'upcoming':
      return 'bg-gradient-to-r from-blue-500 to-cyan-500'
    case 'active':
      return 'bg-gradient-to-r from-green-500 to-emerald-500'
    case 'completed':
      return 'bg-gradient-to-r from-gray-400 to-slate-400'
    default:
      return 'bg-gradient-to-r from-gray-400 to-slate-400'
  }
}

// Get status badge class
const getStatusBadgeClass = (schedule: ScheduleEntry): string => {
  const status = getScheduleStatus(schedule)
  switch (status) {
    case 'upcoming':
      return 'bg-blue-100 text-blue-800'
    case 'active':
      return 'bg-green-100 text-green-800'
    case 'completed':
      return 'bg-gray-100 text-gray-700'
    default:
      return 'bg-gray-100 text-gray-700'
  }
}

// Get status text with countdown
const getStatusText = (schedule: ScheduleEntry): string => {
  const status = getScheduleStatus(schedule)
  const now = currentTime.value
  const scheduleDate = new Date(schedule.startDate || schedule.usageDate!)
  const [startHour, startMinute] = schedule.startTime.split(':').map(Number)
  const [endHour, endMinute] = schedule.endTime.split(':').map(Number)

  const startDateTime = new Date(scheduleDate)
  startDateTime.setHours(startHour, startMinute, 0, 0)

  const endDateTime = new Date(scheduleDate)
  endDateTime.setHours(endHour, endMinute, 0, 0)

  if (status === 'upcoming') {
    // Show countdown to start time
    const diff = startDateTime.getTime() - now.getTime()
    const hours = Math.floor(diff / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

    if (hours > 0) {
      return `อีก ${hours} ชั่วโมง ${minutes} นาที`
    } else if (minutes > 0) {
      return `อีก ${minutes} นาที`
    } else {
      return 'ใกล้จะเริ่ม'
    }
  } else if (status === 'active') {
    // Show "กำลังใช้งาน"
    return 'กำลังใช้งาน'
  } else {
    // Show "เสร็จสิ้น"
    return 'เสร็จสิ้น'
  }
}

// Get status button class
const getStatusButtonClass = (schedule: ScheduleEntry): string => {
  const status = getScheduleStatus(schedule)
  switch (status) {
    case 'upcoming':
      return 'text-orange-600 border-orange-200 hover:text-white hover:bg-orange-600 hover:border-transparent focus:ring-orange-600'
    case 'active':
      return 'text-green-600 border-green-200 hover:text-white hover:bg-green-600 hover:border-transparent focus:ring-green-600'
    case 'completed':
      return 'text-blue-600 border-blue-200 hover:text-white hover:bg-blue-600 hover:border-transparent focus:ring-blue-600'
    default:
      return 'text-gray-600 border-gray-200 hover:text-white hover:bg-gray-600 hover:border-transparent focus:ring-gray-600'
  }
}

// Handle vehicle image error
const onVehicleImageError = (event: Event) => {
  console.warn('Failed to load vehicle image:', event)
  const img = event.target as HTMLImageElement
  if (img && img.parentElement) {
    img.style.display = 'none'
  }
}

// Handle driver image error
const onDriverImageError = (event: Event) => {
  console.warn('Failed to load driver avatar image:', event)
  const img = event.target as HTMLImageElement
  if (img) {
    img.style.display = 'none'
  }
}

// Load data on mount
onMounted(async () => {
  try {
    await Promise.all([
      scheduleStore.fetchAllScheduleEntries(),
      vehicleStore.fetchAllVehicles(),
      driverStore.fetchAllDrivers()
    ])

    // Start timer for real-time countdown
    timerInterval = window.setInterval(() => {
      currentTime.value = new Date()
    }, 1000) // Update every second
  } catch (error) {
    console.error('Error loading dashboard data:', error)
  }
})

// Cleanup on unmount
onUnmounted(() => {
  if (timerInterval !== null) {
    clearInterval(timerInterval)
  }
})
</script>